import * as constants from '../constants/actions';

const initialState = {
  locations: [],
  selectedLocation: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.STORE_LOCATIONS_SAVE:
      return locationsSave(state, action);
    case constants.STORE_SELECT_LOCATION:
    	return locationsSelect(state, action);
	  default:
	    return state;
  }
}


function locationsSave(state, action) {
  return Object.assign({}, state, {
  	locations: action.locations,
  });
}

function locationsSelect(state, action) {
  return Object.assign({}, state, {
  	selectedLocation: action.location,
  });
}